import { Sidebar } from '@side/pantry';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { SideBarContent } from 'src/components/SideBar/SideBarContent';
import { useInteraction } from '@/common/hooks/useInteraction';
import { useSafeInteractionParams } from '@/common/hooks/useSafeInteractionParams';
import { formatAddress } from '@/common/utils/address';
import { useInteractionStatus } from './useInteractionStatus';

export const SideBar = () => {
  const { basePath } = useRouter();
  const { interactionType, interactionId } = useSafeInteractionParams();

  const { data: interaction } = useInteraction(interactionId, interactionType);
  const address = formatAddress(interaction?.property, {
    includeStreet2: true,
  });
  const {
    statuses,
    loading: statusLoading,
    status,
    onChangeStatus,
    isArchived,
    isTransactionStatusLocked,
  } = useInteractionStatus();

  return (
    <Sidebar
      linkComponent={NextLink}
      showArchivedMessage={isArchived}
      interactionType={interactionType}
      address={address}
      leaseRepresentation={interaction?.representation ?? undefined}
      basePath={basePath}
      TransactionStatusDropdownProps={{
        statuses,
        value: status,
        onChange: (e) => {
          void onChangeStatus(e.target.value);
        },
        loading: statusLoading,
        isTransactionStatusLocked,
      }}
    >
      <SideBarContent />
    </Sidebar>
  );
};
